export default __webpack_public_path__ + "static/media/html.7ba7fad9.svg";